module.exports = __webpack_public_path__ + "img/IMG-20200823-WA0040.5b7db199.jpg";